import { DatePicker } from 'antd'

import Styled from './styled'

export default function MyDatePicker(props) {
  const datePickerProps = {
    ...props,
  }

  return (
    <Styled className="date-picker-component">
      <DatePicker {...datePickerProps} />
    </Styled>
  )
}
